export const ATTACHMENTS_BUCKET =
  import.meta.env.VITE_ATTACHMENTS_BUCKET || "attachments";

// Public pictures: company logos, the app logo, member avatars.
export const LOGOS_BUCKET = import.meta.env.VITE_LOGOS_BUCKET || "logos";
